import { IconButton } from "@chakra-ui/react";
import { MdDragIndicator } from "react-icons/md";

export const DragHandle = () => 
    <IconButton
        variant='ghost' background='none' className='handle'
        _hover={{ bg: 'none' }}
        _focus={{ bg: 'none' }}
        _active={{ bg: 'none' }}
        tabIndex='-1'
        cursor='grab'
        icon={<MdDragIndicator size={25}/>}
    />